import Api from '../../library/api';
import { showError } from '../snackbars/snackbars-actions';

export const REQUEST_AVAILABLE_DRIVERS = 'REQUEST_AVAILABLE_DRIVERS';
export const SET_AVAILABLE_DRIVERS = 'SET_AVAILABLE_DRIVERS';

export function getAvailableDrivers() {
  return dispatch => {

    dispatch({type: REQUEST_AVAILABLE_DRIVERS});

    Api.post('p/admin/available-drivers')
      .then(resp => {

        if (resp.err) {
          dispatch(showError(resp.err));
          return;
        }

        dispatch({
          type: SET_AVAILABLE_DRIVERS,
          payload: resp
        })

      })
  }
}


// WEBPACK FOOTER //
// ./src/components/available-drivers/available-drivers-actions.js